import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import PhoneIcon from "../icons/PhoneIcon";
import WhatsAppIcon from "../icons/WhatsAppIcon";
import { getUserContactInfo } from "../../api/UsersApi";
import "./ContactInfoModal.css";

type ContactInfoModalProps = {
  userId: string;
  userName: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function ContactInfoModal({ userId, userName, isOpen, onClose }: ContactInfoModalProps) {
  const { t } = useTranslation();
  const [contactInfo, setContactInfo] = useState<{ email?: string; phone?: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!isOpen || !userId) {
      setContactInfo(null);
      setError(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(false);
    getUserContactInfo(userId)
      .then((data) => {
        if (!cancelled) {
          setContactInfo({ email: (data as any).email, phone: (data as any).phone });
        }
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [isOpen, userId]);

  return (
    <Modal
      closeOnOverlayClick={true}
      contentClassName="entrevistas-modal-content contact-info-modal"
      isOpen={isOpen}
      onRequestClose={onClose}
      showCloseButton={true}
    >
      <p className="contact-info-name">{userName}</p>
      {loading && <p>{t("pages.entrevistas.contactLoading")}</p>}
      {error && <p>{t("pages.entrevistas.contactError")}</p>}
      {!loading && !error && contactInfo && (
        <div className="contact-info-details">
          {contactInfo.email && (
            <span>
              <strong>{t("pages.entrevistas.contactEmail")}:</strong> {contactInfo.email}
            </span>
          )}
          {contactInfo.phone && (
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <strong>{t("pages.entrevistas.contactPhone")}:</strong>
              {contactInfo.phone}
              <a
                href={`https://wa.me/${contactInfo.phone.replace(/\D/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
                title="WhatsApp"
              >
                <WhatsAppIcon width={20} height={20} />
              </a>
              <a
                href={`tel:${contactInfo.phone}`}
                className="call-link"
                title={t("pages.entrevistas.callPhone")}
              >
                <PhoneIcon width={20} height={20} />
              </a>
            </span>
          )}
        </div>
      )}
    </Modal>
  );
}
